import { DetailsPageActionKeys, EnabledTrackingDetailsPageAction } from './details-page/action-dictionary';
import {
  RecordDetailContext,
  TrackClickBaseActionDetailsPage,
  TrackClickOnToggleFavoriteColumnsAction,
  TrackClickOnSelectUsageAction,
  TrackClickOnToggleSidePanelLocationAction,
  getDetailsActionsEntityDataByEntityType,
  TrackClickOnToggleFavoriteColumnsActionValues,
  TrackClickOnToggleSidePanelLocationActionValues,
} from './details-page/format-helpers';
import { getCompanyTrackingPayload, TrackUserActionID } from './track-user-actions.helper';
import { TrackUserAction } from './track-user-actions.service';

export enum TrackActionScopes {
  RecordDetailsPage = 'recordDetailsPage',
}

export enum TrackActionIdentifiers {
  AddUsage = 'addUsage',
  SelectUsage = 'selectUsage',
  ToggleFavoriteColumns = 'hideFavoriteColumns',
  TogglePanelLocation = 'togglePanelLocation',
  CompleteDealTIM = 'completeDealTIM',
  AddCompany = 'addCompany',
  DeleteCompany = 'deleteCompany',
  SelectComplex = 'selectComplex',
  ExternalRatings = 'externalRatings',
}

export interface SearchTrackingInfo {
  actionId: number;
  actionDetails: Record<string, any>;
}

export const TrackActionIdentifierDictionary = {
  [TrackActionScopes.RecordDetailsPage]: {
    [TrackActionIdentifiers.AddUsage]: (
      context: RecordDetailContext
    ): TrackUserAction<TrackClickBaseActionDetailsPage> =>
      EnabledTrackingDetailsPageAction[context.recordState.type]
        ? {
            actionId: DetailsPageActionKeys.AddUsage,
            actionDetails: getDetailsActionsEntityDataByEntityType[context.recordState.type]?.(context),
          }
        : null,

    [TrackActionIdentifiers.SelectUsage]: (
      context: RecordDetailContext
    ): TrackUserAction<TrackClickOnSelectUsageAction> =>
      EnabledTrackingDetailsPageAction[context.recordState.type]
        ? {
            actionId: DetailsPageActionKeys.SelectUsage,
            actionDetails: {
              ...getDetailsActionsEntityDataByEntityType[context.recordState.type]?.(context),
              value: context.recordState.selectedUsage,
            },
          }
        : null,

    [TrackActionIdentifiers.ToggleFavoriteColumns]: (
      context: RecordDetailContext
    ): TrackUserAction<TrackClickOnToggleFavoriteColumnsAction> =>
      EnabledTrackingDetailsPageAction[context.recordState.type]
        ? {
            actionId: DetailsPageActionKeys.ToggleFavoriteColumns,
            actionDetails: {
              ...getDetailsActionsEntityDataByEntityType[context.recordState.type]?.(context),
              value: context.formViewState.showFavorites
                ? TrackClickOnToggleFavoriteColumnsActionValues.showFavs
                : TrackClickOnToggleFavoriteColumnsActionValues.showAll,
            },
          }
        : null,

    [TrackActionIdentifiers.TogglePanelLocation]: (
      context: RecordDetailContext
    ): TrackUserAction<TrackClickOnToggleSidePanelLocationAction> =>
      EnabledTrackingDetailsPageAction[context.recordState.type]
        ? {
            actionId: DetailsPageActionKeys.ToggleSidePanelLocation,
            actionDetails: {
              ...getDetailsActionsEntityDataByEntityType[context.recordState.type]?.(context),
              value: context.formViewState.beastMode
                ? TrackClickOnToggleSidePanelLocationActionValues.beasModeActive
                : TrackClickOnToggleSidePanelLocationActionValues.beasModeInActive,
            },
          }
        : null,

    [TrackActionIdentifiers.CompleteDealTIM]: (
      context: RecordDetailContext
    ): TrackUserAction<TrackClickBaseActionDetailsPage> =>
      EnabledTrackingDetailsPageAction[context.recordState.type]
        ? {
            actionId: DetailsPageActionKeys.CompleteTIM,
            actionDetails: getDetailsActionsEntityDataByEntityType[context.recordState.type]?.(context),
          }
        : null,
    [TrackActionIdentifiers.AddCompany]: (context: RecordDetailContext) =>
      EnabledTrackingDetailsPageAction[context.recordState.type]
        ? getCompanyTrackingPayload(context, TrackUserActionID.AddCompany)
        : null,
    [TrackActionIdentifiers.DeleteCompany]: (context: RecordDetailContext) =>
      EnabledTrackingDetailsPageAction[context.recordState.type]
        ? getCompanyTrackingPayload(context, TrackUserActionID.DeleteCompany)
        : null,
    [TrackActionIdentifiers.SelectComplex]: (context: RecordDetailContext) =>
      EnabledTrackingDetailsPageAction[context.recordState.type]
        ? getCompanyTrackingPayload(context, TrackUserActionID.SelectComplex)
        : null,
    [TrackActionIdentifiers.ExternalRatings]: (context: RecordDetailContext) =>
      EnabledTrackingDetailsPageAction[context.recordState.type]
        ? getCompanyTrackingPayload(context, TrackUserActionID.ExternalRatings)
        : null,
  },
};
